import { W as WuiDateRangeInputWithPresets$1, d as defineCustomElement$1 } from './p-CaXf8uSH.js';

const WuiDateRangeInputWithPresets = WuiDateRangeInputWithPresets$1;
const defineCustomElement = defineCustomElement$1;

export { WuiDateRangeInputWithPresets, defineCustomElement };
